// Registered before the details route: `create` would otherwise be read as a request id.
export default {
  path: 'winter-service/v2/requests/create',
  name: 'WinterService2RequestCreate',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/RequestCreate.vue')
}
